import AbstractControlEditor from "@/components/CustomForm/Design/ControlEditor/AbstractControlEditor";

export default class BatchUploadEditor extends AbstractControlEditor {}
